<template>
    <!-- Основной контейнер страницы -->
    <MainLayout>
        
        <!-- Кнопка "Добавить в наличие" -->
        <button class="add-to-presence" @click="openAddProductModal">
            Добавить в наличие
        </button>

        <!-- Контейнер для блоков с товарами -->
        <div class="product-container">
            <ManagerProductCard
                v-for="product in products"
                :key="`product-${product.id}`"
                :product="product"
                @deleted="handleProductDelete"
                @updated="handleUpdateProduct"
                @refresh-requested="fetchProducts"
            />
        </div>

    </MainLayout>

    <!-- Модальное окно для добавления товара -->
    <ProductModifyWindow 
        style="position: fixed; top: 0; left: 0;" 
        v-if="isModifyModalVisible"
        :is-add="isAddMode"
        :categories="categories"
        :available-sizes="sizes"
        :product="editProduct"
        @submit="handleProductSubmit"
    />
</template>

<script>
import MainLayout from '@/components/MainLayout.vue';
import ManagerProductCard from '@/components/ManagerProductCard.vue';
import api from '@/api/api';
import ProductModifyWindow from '@/components/modal-windows/ProductModifyWindow.vue';

export default {
    components: {
        MainLayout,
        ManagerProductCard,
        ProductModifyWindow,
    },  

    data() {
        return {
            products: [],

            // Переменная для отображения модального окна добавления/изменения товара
            isModifyModalVisible: false,
            isAddMode: true,
            categories: [],
            sizes: [],

            productContainerKey: 0,

            // Данные о товаре для изменения
            editProduct: Object,
        }
    },

    methods: {

        // Обработка изменения данных о товаре 
        handleUpdateProduct(product) {

            // Передаем данные о товаре в модальное окно
            this.editProduct = product;

            // Меня режим на изменение
            this.isAddMode = false;

            // Отображаем модальное окно
            this.isModifyModalVisible = true;

            // E,bhftv обработчик кнопки назад при открытии модального окна
            if (window.Telegram.WebApp) {   
                window.Telegram.WebApp.BackButton.offClick(this.backButtonOnClick);
                window.Telegram.WebApp.BackButton.hide();
                window.Telegram.WebApp.BackButton.onClick(this.closeModifyProductModal);
                window.Telegram.WebApp.BackButton.show();
            }
        },

        // Обработка успешного удаления
        async handleProductDelete() {
            console.log('✅ Товар удален, обновляем список...');
            
            // 1. Ждем немного
            await new Promise(resolve => setTimeout(resolve, 300));
            
            // 2. Перезагружаем все товары с сервера
            await this.fetchProducts();
            
            console.log('✅ Список товаров обновлен');
        },

        // Обработка успешного создания
        async handleProductSubmit() {
            console.log('✅ Товар создан, обновляем список...');

            // возвращаем обработчик кнопки назад при закрытии модального окна
            if (window.Telegram.WebApp) {
                window.Telegram.WebApp.BackButton.offClick(this.closeModifyProductModal)
                window.Telegram.WebApp.BackButton.hide();

                window.Telegram.WebApp.BackButton.onClick(this.backButtonOnClick);
                window.Telegram.WebApp.BackButton.show();
            }
            
            // 1. Закрываем модальное окно
            this.isModifyModalVisible = false;
            
            // 2. Ждем немного
            await new Promise(resolve => setTimeout(resolve, 300));
            
            // 3. Перезагружаем все товары с сервера
            await this.fetchProducts();
            
            console.log('✅ Список товаров обновлен');

        },

        // Запрос карточек продуктов
        async fetchProducts() {
            try {
                const response = await api.get('/accounting_system/products');
                this.products = response.data;
            } catch (error) {
                console.error('Ошибка при получении продуктов:', error);
            }
        },

        // Отображаем кнопку назад (Telegram mini app)
        backButtonOnClick() {
            if (window.Telegram.WebApp) {
                window.history.back();
            }
        },

        // Открытие модального окна добавления товара
        openAddProductModal() {
            this.isAddMode = true;
            this.isModifyModalVisible = true;

            // убирае обработчик кнопки назад при открытии модального окна
            if (window.Telegram.WebApp) {
                window.Telegram.WebApp.BackButton.offClick(this.backButtonOnClick);
                window.Telegram.WebApp.BackButton.hide();
                window.Telegram.WebApp.BackButton.onClick(this.closeModifyProductModal);
                window.Telegram.WebApp.BackButton.show();
            }
        },

        // Закрытие модального окна добавления/изменения товара
        closeModifyProductModal() {
            this.isModifyModalVisible = false;

            // возвращаем обработчик кнопки назад при закрытии модального окна
            if (window.Telegram.WebApp) {
                window.Telegram.WebApp.BackButton.offClick(this.closeModifyProductModal)
                window.Telegram.WebApp.BackButton.hide();

                window.Telegram.WebApp.BackButton.onClick(this.backButtonOnClick);
                window.Telegram.WebApp.BackButton.show();
            }
        },

        // Получаем категории продуктов
        async fetchCategories() {
            try {
                const response = await api.get('/products/categories/');
                this.categories = response.data;
            } catch (error) {
                console.error('Ошибка при получении категорий продуктов:', error);
            }
        },

        // Получаем размеры продуктов
        async fetchSizes() {
            try {
                const response = await api.get('/accounting_system/sizes/');
                this.sizes = response.data;
            } catch (error) {
                console.error('Ошибка при получении размеров продуктов:', error);
            }
        },
    },
    async mounted() {
        // Получаем все карточки перед загрузкой страницы
        await this.fetchProducts();

        // Получаем категории продуктов
        await this.fetchCategories();

        // Получаем размеры продуктов
        await this.fetchSizes();

        // Отображаем кнопку назад и привязываем обработчик
        if (window.Telegram.WebApp) {
            window.Telegram.WebApp.BackButton.onClick(this.backButtonOnClick);
            window.Telegram.WebApp.BackButton.show();
        }
    },
    beforeUnmount() {
        // Убираем обработчик кнопки назад при уходе со страницы
        if (window.Telegram.WebApp) {
            window.Telegram.WebApp.BackButton.offClick(this.backButtonOnClick);
            window.Telegram.WebApp.BackButton.hide();
        }
    },
}
</script>

<style scoped>
.add-to-presence {
    width: 100%;
    height: 10vw;
    border-radius: 10px;
    font-size: 18px;
    color: white;
    background-color: #005ADA;
    border: none;
    margin-bottom: 3vw;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
}

.add-to-presence:active {
    transform: scale(0.90);
}

.product-container {
    display: flex;
    flex-direction: column;
    gap: 2vw;
}
</style>